import React from 'react';

const ThumbsUpIcon = ({ color="#0AB", fill, ...props }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={16} 
        height={16}
        viewBox="0 0 24 24" 
        fill={ fill ? color :"none"} 
        stroke={color}
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        class="lucide lucide-thumbs-up-icon lucide-thumbs-up"
    >
        <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>
        <path d="M7 10v12"/>
    </svg>
);

export default ThumbsUpIcon;